import React, { useState } from 'react'
import { Wrapper } from './style'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { validatePlanNameAction } from 'src/redux/actions/planAction'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { ModalTitleText } from 'src/components/Global/Text/TitleText'

const TargetName = () => {
  const [planData, setPlanData] = useState({
    plan_name: '',
    plan_type: 'target',
  })
  const payload = {
    TargetName: {
      ...planData,
    },
  }
  const validateTargetName = (e: any) => {
    dispatch(validatePlanNameAction(payload))
  }
  let location = useLocation()
  const dispatch = useDispatch()
  const { plan_name } = planData

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, newData))
  }
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <ModalTitleText>Goal</ModalTitleText>
          <p className="desc">What do you want to save towards?</p>
          <QuicksaveInput
            type="text"
            name="plan_name"
            value={plan_name}
            placeholder="e.g vacation"
            onChange={handleChange}
            onBlur={validateTargetName}
          />
        </div>
        <div>
          <Link
            to={`/target-timeline`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className="button">Continue</ModalButton>
          </Link>
        </div>
      </form>
    </Wrapper>
  )
}

export { TargetName }
